<template>
    <excel-export class="w-100" :data="processedItems"
        :fields="excelFields" worksheet="Reuniones" name="reuniones_compliance.xlsx">
    </excel-export>
</template>

<script>
import { formatAssistantName, formatDateTime, formatComment } from '@/plugins/complianceScripts'
import ExcelExport from '@/components/shared/ExcelExport.vue';

export default {
    name: 'MeetingReportExcel',

    components: {
        ExcelExport
    },

    props: {
        items: Array
    },

    methods: {
        getDuration(dateStart, dateEnd) {
            return Math.floor((new Date(dateEnd) - new Date(dateStart)) / (1000 * 60));
        },

        isVirtual(row) {
            return row.place === 'virtualPlace'
        }
    },

    computed: {
        processedItems() {
            if (!this.items) {
                return []
            }

            return this.items.map(item => ({
                ...item,
                duration: this.getDuration(item.dateStart, item.dateEnd),
                location: this.isVirtual(item) ? 'Virtual' : item.address,
                creationDateFormatted: formatDateTime(item.creationDate),
                dateStartFormatted: formatDateTime(item.dateStart),
                assistantsList: item.assistants.map(assistant =>
                    `${formatAssistantName(assistant)} (${assistant.mail})`
                ).join(', '),
                commentsList: item.comments.map(comment =>
                    `${formatComment(comment)} `
                ).join(', ')
            }));
        },
        
        excelFields() {
            return {
                'Título': {
                    field: 'summary',
                    width: 20,
                },
                'Organizador': {
                    field: 'organizer',
                    width: 30,
                },
                'Fecha creación': {
                    field: 'creationDateFormatted',
                    width: 20,
                },
                'Fecha inicio': {
                    field: 'dateStartFormatted',
                    width: 25,
                },
                'Duración (minutos)': {
                    field: 'duration',
                    width: 25,
                },
                'Lugar': {
                    field: 'location',
                    width: 25,
                },
                'Invitados': {
                    field: 'assistantsList',
                    width: 60,
                },
                'Comentarios': {
                    field: 'commentsList',
                    width: 60,
                }
            }
        }
    }
}
</script>